export enum PersonTitle {
  ADMIN = 'admin',
  USER = 'user',
  WRITER = 'writer'
}

export enum PersonTitlePersian {
  ADMIN = 'پنل ادمین',
  user = 'پنل کاربر',
  writer = 'پنل نویسنده'
}